module.exports = __webpack_public_path__ + "img/pic_5.8b65c9f9.jpg";